import _ from 'lodash';
import app from '$$app';
import routerHelper from '$$routerHelper';
import store from '$$globalStore';
import {
  findListViewCellElement,
  getTimeLogListViewCellPosition,
  setPendingTimeLogPopupOpen,
} from '../components/timeTracking/getTimeLogComments';
import { resolveListViewTooltipPositionAtShow } from '../views/listView/table/helpers/getListViewTooltipPosition';

const __ = window.__;

app.on('app:start', () => {
  const tooltipClass = 'tooltip-gantt';
  let container;
  let container_triangle;
  let container_content;
  let html;
  const containerClassName = 'tooltip-gantt-container';
  let currentTooltipElement = null;
  let currentTimeLogAnchor = null;

  function handleTimeLogLearnMoreClick(anchorElement) {
    const taskId = anchorElement?.dataset?.taskId;

    if (!taskId) {
      return;
    }

    const cellId = anchorElement?.dataset?.cellId
      || anchorElement?.closest?.('[data-list-view-cell]')?.getAttribute('data-list-view-cell');
    const cellEl = findListViewCellElement(cellId);
    const pos = getTimeLogListViewCellPosition(anchorElement, cellId);

    setPendingTimeLogPopupOpen({ fromLearnMore: true, pos });

    hideTooltip(true);

    if (cellEl) {
      cellEl.click();
    }

    // Virtual scroll may replace row nodes — retry on the live cell, then open popup.
    setTimeout(() => {
      const popup = typeof $$ !== 'undefined' ? $$('timeTrackingPopup') : null;

      if (popup?.isVisible?.()) {
        return;
      }

      const liveCellEl = findListViewCellElement(cellId);

      if (liveCellEl && liveCellEl !== cellEl) {
        liveCellEl.click();
      }

      setTimeout(() => {
        if (typeof $$ !== 'undefined' && $$('timeTrackingPopup')?.isVisible?.()) {
          return;
        }

        app.trigger('showTimeTrackingPopup', 'task', pos, +taskId, null, 'history');
      }, 0);
    }, 0);
  }

  function initContainer() {
    container_content = document.createElement('div');
    container_triangle = document.createElement('div');
    container = document.createElement('div');

    container.style.maxWidth = '250px';

    container_content.className = 'tooltip-gantt-content';
    container_triangle.className = 'tooltip-gantt-triangle';
    container.className = containerClassName;

    container.appendChild(container_content);
    container.appendChild(container_triangle);
    document.body.appendChild(container);

    container.style.visibility = 'hidden';
  }

  function showTooltip(event) {
    const target = event.target;
    const tooltipAnchor = getTooltipElement(target, 'pricing-tooltip');
    const debounced = _.debounce(() => {
      initTooltip(getTooltipElement(target, tooltipClass));
    });

    if (tooltipAnchor) {
      document.querySelectorAll('.pricing-tooltip').forEach(item => {
        item.classList.remove('pricing-border');
      });
    }

    if (tooltipAnchor || getTooltipElement(target, 'tooltip-container')) {
      store.commit('tooltip/showPricingPopup', true);
      if (tooltipAnchor && tooltipAnchor.dataset) {
        store.commit('tooltip/setConfig', {
          feature: tooltipAnchor.dataset.feature,
          target: tooltipAnchor.getBoundingClientRect(),
          position: tooltipAnchor.dataset.position,
          additionalDif: tooltipAnchor.dataset.additionalDif,
          class: tooltipAnchor.dataset.class,
        });
      }
    } else {
      store.commit('tooltip/showPricingPopup', false);
    }

    if (!hasFocusOnTooltip(target)) {
      debounced.cancel();
      hideTooltip();
    }

    debounced();
  }

  function onMouseLeave() {
    if (container.innerHTML && container.innerHTML.includes('<a href')) {
      return false;
    }

    const showMoreBtn = container.querySelector('.tooltip_gantt_show_more');

    if (showMoreBtn && showMoreBtn.style.display !== 'none') {
      return false;
    }

    debouncedTooltip.cancel();
    hideTooltip(true);

    return false;
  }

  function initTooltip(element) {
    if (!element) {
      return;
    }

    if (element.offsetParent && element.offsetParent.classList.contains('estimate_total')) {
      return false;
    }

    currentTooltipElement?.removeEventListener('mouseleave', onMouseLeave);
    currentTooltipElement = element;
    currentTooltipElement.addEventListener('mouseleave', onMouseLeave);

    const yOffset = ~~(element.dataset.y || 0);
    const xOffset = ~~(element.dataset.x || 0);
    let tooltipPosition = element.dataset.position || 'top';
    const align = element.dataset.align || null;
    const maxWidth = element.dataset.maxwidth || 250;
    const padding = element.dataset.padding || '16px';

    container.style.maxWidth = `${maxWidth}px`;
    container_content.style.padding = '8px 12px';

    let elementPosition = element.getBoundingClientRect();
    let elementHTML = element;

    if (element.dataset.name === 'text' && element.dataset.id) {
      elementPosition = element.querySelector('.text_value_content').getBoundingClientRect();
      elementHTML = element.querySelector('.text_value_content');
    }

    if (!element.classList.contains('pricing-tooltip')) {
      if (element.dataset.key) {
        setContentByKey(element.dataset.key);
      } else if (element.dataset.html === 'true' || element.dataset.name === 'text') {
        let id = null;

        if (element.dataset.id) {
          id = element.dataset.id.includes('_') ? element.dataset?.id.split('_')[0] : +element.dataset.id;
        }

        html = element.querySelector('.tooltip-gantt-html');
        container.classList.add('tooltip-gantt-container-html');

        if (element.dataset.timeLogTooltip === 'true') {
          container_content.innerHTML = '';
          container_content.appendChild(html.cloneNode(true));
          initTimeLogTooltip(element);
        } else {
          setContentByHTML(html.cloneNode(true));
        }

        document.querySelector('.tooltip-gantt-container-html').querySelectorAll('a').forEach(item => {
          if (item.classList.contains('tooltip_gantt_show_more') || item.closest('.tooltip_gantt_show_more')) {
            return;
          }
          if (!item.getAttribute('target')) {
            item.setAttribute('target', '_self');
          }
          item.setAttribute('title', __('click_to_follow_by_link'));
        });

        if (id) {
          const link = container.querySelector('.tooltip_gantt_show_more');
          const tooltipMaxHeight = Math.round((document.body.clientHeight / 2) - 120);
          const tooltipHeight = container.clientHeight;

          if (tooltipHeight > tooltipMaxHeight) {
            const linkHeight = 15;
            const title = container.querySelector('.tooltip-gantt-html-title');
            const description = container.querySelector('.tooltip-gantt-html-description');
            const maxHeight = Math.round(tooltipMaxHeight - title.getBoundingClientRect().height - linkHeight);

            let resHeight = 0;

            if (description) {
              _.forEach(description.children, elem => {
                const elemHeight = elem.offsetHeight;

                if ((resHeight + elemHeight) < maxHeight) {
                  resHeight += elemHeight;
                } else {
                  const elemLineHeight = parseInt(getComputedStyle(elem).lineHeight);
                  const heightRemainder = maxHeight - resHeight;
                  const maxVisibleLines = Math.floor(heightRemainder / elemLineHeight);

                  resHeight += (maxVisibleLines * elemLineHeight);

                  return false;
                }
              });
              description.style.height = `${resHeight}px`;
            }

            if (link) {
              link.onclick = function (e) {
                showTaskSettings(id, { selectDescription: true });
                hideTooltip(true);
              };
            }
          } else if (link) link.style.display = 'none';
        }
      } else {
        return;
      }
      const container_width = container_content.clientWidth;
      const container_height = container_content.clientHeight;

      if (element.dataset.listViewHeaderFlip === 'true') {
        tooltipPosition = resolveListViewTooltipPositionAtShow(
          element,
          elementPosition,
          container_height,
          yOffset,
          tooltipPosition,
        );
      }

      const deviation = getDiviation(container_width, container_height, elementPosition);

      if (element.dataset.name === 'text' || elementHTML.closest('.cell-task-name')) {
        deviation.x = 0;
      }

      setPosition(
        container,
        tooltipPosition,
        elementHTML,
        elementPosition,
        container_height,
        container_width,
        yOffset,
        xOffset,
        deviation,
        container_triangle,
      );

      // Above webix popups (time tracking, etc.) so coords stay tied to the trigger
      const hostWindow = element.closest('.webix_window');

      if (hostWindow) {
        const hostZIndex = parseInt(window.getComputedStyle(hostWindow).zIndex, 10);

        if (Number.isFinite(hostZIndex)) {
          container.style.zIndex = String(hostZIndex + 1);
        }
      } else {
        container.style.zIndex = '';
      }

      container.style.visibility = 'visible';

      container.style.opacity = '.85';
      container.style.transform = 'scale3d(1,1,1)';

      if (element.dataset.timeLogTooltip === 'true') {
        const root = container_content.querySelector('.time-log-tooltip');
        const tooltipMaxWidth = Number(element.dataset.maxwidth) || 234;
        const tooltipMaxHeight = Number(element.dataset.maxheight) || 200;

        layoutTimeLogTooltip(root, container_content, element, tooltipMaxWidth, tooltipMaxHeight);
      }

      if (align) {
        setAlign(align, container, container_triangle, elementPosition, tooltipPosition);
      }
    }
  }

  function setAlign(align, container, container_triangle, elementPosition, tooltipPosition) {
    switch (align) {
      case 'center':
        break;
      case 'right':
        if (tooltipPosition === 'top' || tooltipPosition === 'bottom') {
          container.style.left = `${elementPosition.left - container.offsetWidth + elementPosition.width + 8}px`;
          container_triangle.style.transform = `translateX(${container.offsetWidth / 2 - 20}px)`;
        }
        break;
      case 'left':
        if (tooltipPosition === 'top' || tooltipPosition === 'bottom') {
          container.style.left = `${elementPosition.left - 8}px`;
          container_triangle.style.transform = `translateX(${-(container.offsetWidth / 2 - 20)}px)`;
        }
        break;
      default:
    }
  }

  function setPosition(container, tooltipPosition, element, elementPosition, container_height, container_width, yOffset, xOffset, deviation, container_triangle) {
    // Prefer viewport size from getBoundingClientRect (same space as left/top)
    const elementWidth = elementPosition.width || element.offsetWidth;
    const elementHeight = elementPosition.height || element.offsetHeight;

    ['triangle_bottom', 'triangle_top', 'triangle_left', 'triangle_right'].forEach(cls => {
      container.classList.remove(cls);
    });

    switch (tooltipPosition) {
      case 'top':
        if (elementPosition.top > container_height + 17) {
          container.classList.add('triangle_bottom');
          container.style.top = `${elementPosition.top - container.offsetHeight - 7 + yOffset}px`;
        } else {
          container.classList.add('triangle_top');
          container.style.top = `${elementPosition.top + elementHeight + 17 + yOffset - deviation.y}px`;
        }

        if (deviation.x > elementWidth / 2) {
          container.style.left = `${elementPosition.left - container_width + elementWidth}px`;
          container_triangle.style.transform = `translateX(${container_width / 2 - elementWidth / 2}px)`;
        } else {
          // Keep triangle over trigger center when edge-clamp shifts the box
          container.style.left = `${elementPosition.left + elementWidth / 2 - container_width / 2 - 1 + xOffset - deviation.x}px`;
          container_triangle.style.transform = `translateX(${deviation.x}px)`;
        }
        break;
      case 'bottom':
        container.classList.add('triangle_top');
        container.style.top = `${elementPosition.top + elementHeight + 17 + yOffset}px`;

        if (deviation.x > 110) {
          container.style.left = `${elementPosition.left - container_width + elementWidth}px`;
          container_triangle.style.transform = `translateX(${container_width / 2 - elementWidth / 2}px)`;
        } else {
          container.style.left = `${elementPosition.left + elementWidth / 2 - container_width / 2 - 1 + xOffset - deviation.x}px`;
          container_triangle.style.transform = `translateX(${deviation.x}px)`;
        }
        break;
      case 'left':
        container.style.left = `${elementPosition.left - container_content.clientWidth - 30 + xOffset}px`;
        container.style.top = `${elementPosition.top - yOffset - deviation.y}px`;
        container.classList.add('triangle_right');
        container_triangle.style.transform = `translateX(0px) translateY(${deviation.y}px)`;

        break;
      case 'right': {
        const margin = 17;
        const idealTop = elementPosition.top + (elementHeight / 2) - (container_height / 2) + yOffset;
        const top = Math.max(margin, idealTop);

        container.style.left = `${elementPosition.left + elementWidth + xOffset}px`;
        container.style.top = `${top}px`;
        container.classList.add('triangle_left');
        container_triangle.style.transform = 'translateX(0px)';
        break;
      }
      default:
    }
  }

  function getDiviation(containerWidth, containerHeight, elementPosition) {
    const deviation = {
      x: 0,
      y: 0,
    };
    const margin = 17;
    // Same viewport space as position:fixed + getBoundingClientRect
    const viewportWidth = document.documentElement.clientWidth;
    const viewportHeight = document.documentElement.clientHeight;
    // Tooltip is centered on the trigger — clamp against that ideal box, not the trigger's right edge
    const idealLeft = elementPosition.left + elementPosition.width / 2 - containerWidth / 2;
    const idealRight = idealLeft + containerWidth;

    if (idealRight > viewportWidth - margin) {
      deviation.x = idealRight - (viewportWidth - margin);
    } else if (idealLeft < margin) {
      deviation.x = idealLeft - margin;
    }

    if (Math.abs(deviation.x) > (containerWidth - 10)) {
      deviation.x = deviation.x < 0 ? -(containerWidth - 10) : containerWidth - 10;
    }

    if (containerHeight > (viewportHeight - elementPosition.bottom)) {
      deviation.y = containerHeight - (viewportHeight - elementPosition.bottom);
    }

    return deviation;
  }

  function hideTooltip(force) {
    if (!force) {
      container.style.opacity = '0';
      container.style.transform = 'scale3d(1,.96,1)';
    }

    container.style.visibility = 'hidden';

    container.style.width = '';
    container.style.zIndex = '';
    container_content.innerHTML = '';
    container.classList.remove('tooltip-gantt-container-html');

    if (currentTooltipElement) {
      currentTooltipElement.removeEventListener('mouseleave', onMouseLeave);
      currentTooltipElement = null;
    }

    currentTimeLogAnchor = null;
  }

  function setContentByKey(key) {
    const exp = /([^"]|^)(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig;
    const res = key.replace(exp, `$1<a href="$2" target="_blank" title="${__('click_to_follow_by_link')}">$2</a>`);

    container_content.innerHTML = __(res.replace(/(?:\r\n|\r|\n)/g, '<br/>'));
  }

  function setContentByHTML(html) {
    container_content.innerHTML = parseDescription(html.innerHTML);
  }

  const TIME_LOG_ENTRY_GAP = 4;

  function getTimeLogTooltipLineWidth(contentEl, maxWidth) {
    const styles = contentEl ? getComputedStyle(contentEl) : null;
    const paddingLeft = parseFloat(styles?.paddingLeft) || 12;
    const paddingRight = parseFloat(styles?.paddingRight) || 12;

    return Math.max(0, maxWidth - paddingLeft - paddingRight);
  }

  function resetTimeLogCommentLine(commentEl) {
    if (!commentEl) {
      return;
    }

    commentEl.style.display = '';
    commentEl.style.webkitBoxOrient = '';
    commentEl.style.webkitLineClamp = '';
    commentEl.style.lineClamp = '';
    commentEl.style.overflow = '';
    commentEl.style.textOverflow = '';
    commentEl.style.whiteSpace = '';
    commentEl.style.wordBreak = '';
  }

  function applyTimeLogCommentLineClamp(commentEl, maxHeightPx) {
    if (!commentEl || maxHeightPx <= 0) {
      return;
    }

    const lineHeight = parseFloat(getComputedStyle(commentEl).lineHeight) || 18;
    const maxLines = Math.max(1, Math.floor(maxHeightPx / lineHeight));

    commentEl.style.display = '-webkit-box';
    commentEl.style.webkitBoxOrient = 'vertical';
    commentEl.style.webkitLineClamp = String(maxLines);
    commentEl.style.lineClamp = String(maxLines);
    commentEl.style.overflow = 'hidden';
    commentEl.style.textOverflow = 'ellipsis';
    commentEl.style.whiteSpace = 'normal';
    commentEl.style.wordBreak = 'break-word';
  }

  function applyTimeLogTooltipWidths(root, contentEl, maxWidth) {
    if (!root) {
      return;
    }

    root.classList.remove('tooltip-gantt-html');

    const lineWidth = getTimeLogTooltipLineWidth(contentEl, maxWidth);

    root.style.width = '100%';
    root.style.maxWidth = '100%';
    root.style.boxSizing = 'border-box';

    const entriesEl = root.querySelector('.time-log-tooltip__entries');

    if (entriesEl) {
      entriesEl.style.width = `${lineWidth}px`;
      entriesEl.style.maxWidth = `${lineWidth}px`;
    }

    root.querySelectorAll('.time-log-tooltip__entry').forEach((entry) => {
      entry.style.display = '';
      entry.style.width = '100%';
      entry.style.maxWidth = '100%';
      entry.style.boxSizing = 'border-box';
      resetTimeLogCommentLine(entry.querySelector('.time-log-tooltip__line + .time-log-tooltip__line'));
    });

    root.querySelectorAll('.time-log-tooltip__line').forEach((line) => {
      if (line.classList.contains('time-log-tooltip__more')) {
        return;
      }

      line.style.display = 'block';
      line.style.width = `${lineWidth}px`;
      line.style.maxWidth = `${lineWidth}px`;
      line.style.boxSizing = 'border-box';

      if (line.matches('.time-log-tooltip__entry .time-log-tooltip__line:first-child')) {
        line.style.overflow = 'hidden';
        line.style.textOverflow = 'ellipsis';
        line.style.whiteSpace = 'nowrap';
        line.style.wordBreak = 'normal';
        return;
      }

      if (line.matches('.time-log-tooltip__entry .time-log-tooltip__line + .time-log-tooltip__line')) {
        line.style.overflow = 'hidden';
        line.style.textOverflow = 'ellipsis';
        line.style.whiteSpace = 'normal';
        line.style.wordBreak = 'break-word';
      }
    });
  }

  function layoutTimeLogTooltipEntries(entriesEl, showMoreEl, maxHeight, verticalPadding, moreRowHeight) {
    const entries = [...entriesEl.querySelectorAll('.time-log-tooltip__entry')];
    const contentMaxHeight = maxHeight - verticalPadding;

    entries.forEach((entry) => {
      entry.style.display = '';
      resetTimeLogCommentLine(entry.querySelector('.time-log-tooltip__line + .time-log-tooltip__line'));
    });

    entriesEl.style.maxHeight = '';
    entriesEl.style.overflow = 'hidden';

    const naturalHeight = entriesEl.scrollHeight;
    const hasOverflow = naturalHeight > contentMaxHeight;

    if (!hasOverflow) {
      showMoreEl.style.display = 'none';
      entriesEl.style.overflow = '';

      return false;
    }

    showMoreEl.style.display = '';
    const maxEntriesHeight = maxHeight - verticalPadding - moreRowHeight;

    entriesEl.style.maxHeight = `${maxEntriesHeight}px`;

    let usedHeight = 0;

    for (let i = 0; i < entries.length; i += 1) {
      const entry = entries[i];
      const meta = entry.querySelector('.time-log-tooltip__line:first-child');
      const comment = entry.querySelector('.time-log-tooltip__line + .time-log-tooltip__line');
      const entryGap = i > 0 ? TIME_LOG_ENTRY_GAP : 0;
      const entryHeight = entry.offsetHeight;

      if (usedHeight + entryGap + entryHeight <= maxEntriesHeight) {
        usedHeight += entryGap + entryHeight;
        continue;
      }

      const metaHeight = meta?.offsetHeight || 0;
      const remainingForComment = maxEntriesHeight - usedHeight - entryGap - metaHeight;
      const lineHeight = parseFloat(getComputedStyle(comment || meta).lineHeight) || 18;

      if (comment && remainingForComment >= lineHeight) {
        applyTimeLogCommentLineClamp(comment, remainingForComment);
      } else {
        entry.style.display = 'none';
      }

      for (let j = i + 1; j < entries.length; j += 1) {
        entries[j].style.display = 'none';
      }

      return true;
    }

    return true;
  }

  function layoutTimeLogTooltip(root, contentEl, anchorElement, maxWidth, maxHeight) {
    const entriesEl = root?.querySelector('.time-log-tooltip__entries');
    const showMoreEl = root?.querySelector('.tooltip_gantt_show_more');

    if (!entriesEl || !showMoreEl) {
      return;
    }

    const verticalPadding = 16;
    const moreRowHeight = 22;

    applyTimeLogTooltipWidths(root, contentEl, maxWidth);

    const hasOverflow = layoutTimeLogTooltipEntries(
      entriesEl,
      showMoreEl,
      maxHeight,
      verticalPadding,
      moreRowHeight,
    );

    if (hasOverflow) {
      const link = showMoreEl.querySelector('a');

      if (link) {
        link.onclick = function (e) {
          e.preventDefault();
          e.stopPropagation();
          handleTimeLogLearnMoreClick(anchorElement);
        };
      }
    }
  }

  function initTimeLogTooltip(anchorElement) {
    const root = container_content.querySelector('.time-log-tooltip');
    const entriesEl = root?.querySelector('.time-log-tooltip__entries');
    const showMoreEl = root?.querySelector('.tooltip_gantt_show_more');

    if (!entriesEl || !showMoreEl) {
      currentTimeLogAnchor = null;

      return;
    }

    currentTimeLogAnchor = anchorElement;

    const maxWidth = Number(anchorElement.dataset.maxwidth) || 234;
    const maxHeight = Number(anchorElement.dataset.maxheight) || 200;

    container.style.maxWidth = `${maxWidth}px`;
    container.style.width = `${maxWidth}px`;

    layoutTimeLogTooltip(root, container_content, anchorElement, maxWidth, maxHeight);
  }

  function getTooltipElement(element, cls) {
    return element.closest(`.${cls}`);
  }

  function hasFocusOnTooltip(element) {
    const showMoreBtn = container.querySelector('.tooltip_gantt_show_more');

    if (showMoreBtn && container.contains(element)) {
      return true;
    }

    while (element) {
      if (_.includes(element.classList, 'tooltip-gantt-content')) {
        if (!element.innerHTML.includes('<a href')) {
          return false;
        }

        return true;
      }
      element = element.parentNode;
    }

    return false;
  }

  function parseDescription(text) {
    return text.replace(/(?:\r\n|\r|\n)/g, '');
  }

  function showTaskSettings(taskId, initOptions) {
    if (initOptions) {
      window.taskSettingsData = { initOptions };
    }

    let routeName = routerHelper.getCurrentRoute().name;

    switch (routeName) {
      case 'listView':
        routeName = 'listTaskRoute';
        break;
      case 'project':
        routeName = 'taskRoute';
        break;
      case 'projectsMultiView':
        routeName = 'multiviewTaskRoute';
        break;
    }

    setTimeout(() => {
      routerHelper.pushByNameAndParams(routeName, {
        mode: routerHelper.getCurrentRoute().params.mode,
        taskId,
      });
    });

    userExtAnalytics.log('gantt_task_settings_open', {
      from: routerHelper.analyticsFromRoute(),
      route: `${routerHelper.analyticsRoute()}/ClickOnTooltip`,
    });
  }

  let debouncedTooltip = _.debounce(event => {
    if (store.getters['massChange/isEnabled'] && event.target.closest('.gantt_row')) {
      return;
    }

    if (routerHelper.isTaskSettingsRoute() && event.target.closest('[data-list-view-column-id="text"]')) {
      return;
    }

    if (document.querySelector('.context_menu_popup[view_id="contextMenu"]')?.checkVisibility() && event.target.closest('.gantt_row')) {
      return;
    }

    showTooltip(event);
  }, 600);

  document.querySelector('body').addEventListener('mouseover', debouncedTooltip, false);
  document.addEventListener('click', e => {
    if (debouncedTooltip) {
      debouncedTooltip.cancel();
    }

    if (container.style.visibility === 'hidden') {
      return;
    }

    if (e && e.target && !e.target.closest(`.${containerClassName}`)) {
      hideTooltip(true);

      return false;
    }
  });

  initContainer();

  app.on('gantt:contextMenu:showed', () => {
    if (
      currentTooltipElement
      && currentTooltipElement.classList.contains('gantt_cell')
      && currentTooltipElement.dataset.columnName === 'text'
    ) {
      hideTooltip();
    }
  });
  app.on('tooltip:hide', () => {
    hideTooltip();
  });
});

if (app.config.mode.isLink) {
  app.trigger('app:start');
}
